export const PROSPECTUS_REQUIST = "PROSPECTUS_REQUIST";
export const GET_PROSPECTUS_SUCCESS = "GET_PROSPECTUS_SUCCESS";
export const GET_PROSPECTUS_EMPTY_SUCCESS = "GET_PROSPECTUS_EMPTY_SUCCESS";
export const ADD_PROSPECTUS_SUCCESS = "ADD_PROSPECTUS_SUCCESS";
export const EDIT_PROSPECTUS_SUCCESS = "EDIT_PROSPECTUS_SUCCESS";
export const DELETE_PROSPECTUS_SUCCESS = "DELETE_PROSPECTUS_SUCCESS";
export const PROSPECTUS_FAIELD = "PROSPECTUS_FAIELD";